import type { ItemActivityEvent } from "@forgepoint/shared";
import { useStandardAgentDisplayName } from "@/modules/standardAgent/useStandardAgentDisplayName";
import {
  useQuoteNumberPadWidth,
  useQuoteNumberPrefix,
} from "@/store/quoteSettingsStore";
import { useOrgMembers } from "@/store/teamsStore";
import { actorLine, type ItemHistoryActor } from "./itemHistoryLabels";

/**
 * Resolves who made an item write, with the org's names, photos and quote
 * number format already bound.
 * @returns A function from an item event to its actor
 */
export function useItemHistoryActor(): (
  event: ItemActivityEvent,
) => ItemHistoryActor {
  const agentName = useStandardAgentDisplayName();
  const members = useOrgMembers();
  const padWidth = useQuoteNumberPadWidth();
  const prefix = useQuoteNumberPrefix();
  return (event) => actorLine(event, agentName, members, padWidth, prefix);
}
